import { FileUploadScheduler } from '../../models/FileUploadScheduler';
import { api } from './api';

export const fileUploadSchedulerService = {
  getAll: async (keyword = '', page = 1, pageSize = 10): Promise<{ data: FileUploadScheduler[]; total: number }> => {
    const res = await api.get<{ data: FileUploadScheduler[]; total: number }>(
      '/file-upload-scheduler',
      { params: { keyword, page, pageSize } }
    );
    return res.data;
  },
  getById: async (id: number): Promise<FileUploadScheduler> => {
    const res = await api.get<FileUploadScheduler>(`/file-upload-scheduler/${id}`);
    return res.data;
  },
  create: async (data: Omit<FileUploadScheduler, 'id' | 'createdAt' | 'updatedAt'>): Promise<FileUploadScheduler> => {
    const res = await api.post<FileUploadScheduler>('/file-upload-scheduler', data);
    return res.data;
  },
  update: async (id: number, data: Partial<Omit<FileUploadScheduler, 'id' | 'createdAt' | 'updatedAt'>>): Promise<FileUploadScheduler> => {
    const res = await api.put<FileUploadScheduler>(`/file-upload-scheduler/${id}`, data);
    return res.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/file-upload-scheduler/${id}`);
  },
}; 